<template>
  <div>
    <Alerta :plan="false" :backButton="true" />
    <div class="h-75 d-flex ml-5 align-items-center py-3">
      <div class="row d-flex justify-content-center align-items-center">
        <div class="col-md-2">
          <Stepper :pagamento="true" />
        </div>
        <div class="col-md-5">
          <div class="card">
            <span class="subtitle">Informações de pagamento</span>
            <div class="col-md-7">
              <Input
                title="Cupom"
                v-model="cupom"
                v-if="id_plano == 12"
                @change="setDesconto(cupom)"
                type="text"
                placeholder
              />
            </div>
            <div v-if="installments && id_plano != 12" class="lista-parcelas">
              <label>PARCELAS</label>
              <select
                @change="
                  (e) => (this.cartao.installmentQuantity = e.target.value)
                "
              >
                <option selected>Numero de parcelas</option>
                <option
                  :value="parcela.quantity"
                  :key="parcela.quantity"
                  v-for="parcela in installments"
                >
                  {{ parcela.quantity }}x R${{
                    formatValue(parcela.installmentAmount)
                  }}
                </option>
              </select>
            </div>

            <div class="row">
              <div class="col-md-7">
                <Input
                  title="Nome do titular"
                  v-model="cartao.creditCardHolderName"
                  type="text"
                  placeholder
                />
              </div>
              <div class="col-md-5">
                <Input
                  title="CPF do titular"
                  v-model="cartao.creditCardHolderCPF"
                  type="tel"
                  mask="###.###.###-##"
                  placeholder
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <Input
                  title="Telefone do titular"
                  v-model="cartao.creditCardHolderPhone"
                  type="tel"
                  mask="(##) 9####-####"
                  placeholder
                />
              </div>
              <div class="col-md-6">
                <Input
                  title="Nascimento"
                  v-model="cartao.creditCardHolderBirthDate"
                  mask="##/##/####"
                  type="tel"
                  placeholder="Ex: 12/12/1990"
                />
              </div>
            </div>

            <Input
              title="Numero do cartão"
              v-model="cartao.cardNumber"
              type="tel"
              mask="#### #### #### ####"
              placeholder="Ex: 3443 9090 1431 0912"
            />

            <div class="row">
              <div class="col-md-6">
                <Input
                  title="Validade cartão"
                  v-model="cartao.validade"
                  type="tel"
                  mask="##/####"
                  placeholder="Ex: 02/2022"
                />
              </div>
              <div class="col-md-6">
                <Input
                  title="CVV do cartão"
                  v-model="cartao.cvv"
                  type="tel"
                  mask="###"
                  placeholder="Ex: 123"
                />
              </div>
            </div>
            <button @click="payCard" class="btn-finalizar">
              finalizar pagamento
            </button>
          </div>
        </div>
        <div class="col-md-4 align-self-end">
          <div class="card" style="padding-bottom: 10px !important">
            <span class="subtitle">Informações de pessoais</span>

            <div class="row">
              <div class="col-md-8"></div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <Input
                  title="CEP"
                  @change="getCep(endereco.cep)"
                  mask="#####-###"
                  v-model="endereco.cep"
                  type="tel"
                  placeholder
                />
              </div>
              <div class="col-md-3">
                <Input
                  title="Numero"
                  v-model="endereco.numero"
                  type="tel"
                  placeholder
                />
              </div>
              <div class="col-md-3">
                <Input
                  title="Estado"
                  v-model="endereco.uf"
                  type="text"
                  placeholder
                />
              </div>
            </div>
            <Input
              title="Rua"
              v-model="endereco.logradouro"
              type="text"
              placeholder
            />
            <div class="row">
              <div class="col-md-6">
                <Input
                  title="Cidade"
                  v-model="endereco.localidade"
                  type="text"
                  placeholder
                />
              </div>
              <div class="col-md-6">
                <Input
                  title="Bairro"
                  v-model="endereco.bairro"
                  type="text"
                  placeholder
                />
              </div>
            </div>

            <Input
              title="Complemento"
              v-model="endereco.complemento"
              type="textarea"
              placeholder
            />
          </div>
        </div>
      </div>
    </div>
    <Alerta />
  </div>
</template>
<script>
import "../assets/js/Pagseguro.js";
import Input from "../components/Input";
import Stepper from "../components/Stepper";
import Alerta from "../components/AlertaPlano";
import decode from "jwt-decode";
import firebase from 'firebase';

export default {
  /* eslint-disable */
  name: "Pagamento",
  data: () => ({
    hash: "",
    installments: [],
    cartao: {},
    cupom: "",
    endereco: {
      cep: "",
    },
    id_plano: "",
  }),
  components: {
    Input,
    Stepper,
    Alerta,
  },
  created: async function(){
    this.analyticSubmit();
  },
  mounted: function () {
    let self = this;
    this.$store.commit("jogo", false);

    if (localStorage.getItem("t")) {
      this.$store.commit("loading", true);
      localStorage.setItem("abriuPagamento", true);
      this.id_plano = self.$store.getters.getItemInCart.payload.id; // recebe o id do plano para saber se é da stripe
      console.log(this.id_plano);
      if (self.$store.getters.getItemInCart.payload == undefined) {
        this.$store.commit("setStateModal", {
          visible: true,
          title: "ATENÇÃO",
          type: "warning",
          message:
            "Não conseguimos encontrar um plano para realizar a compra, por favor selecione um plano para continuar",
        });
        self.$router.push({ path: "/assinatura/planos" });
      } else {
        if (self.$store.getters.getItemInCart.payload.valor_a_vista == 0) {
          console.log("Entrou no if da stripe");
          self.$store.commit("loading", true);
          // let plano_id = decode(localStorage.getItem("t")).usr.plano.id;
          // if (plano_id == 12) {
          //   console.log("O cara tem plano da stripe, precisa cancelar");
          //   try {
          //     console.log("Entrou no try catch");
          //     let customer_id = decode(localStorage.getItem("t")).usr.stripe_id;

          //     console.log("Está no meio do try catch");
          //     axios
          //       .get(
          //         "https://api2.arecreativa.com.br/show_customer_subscription",
          //         {
          //           customer_id,
          //         }
          //       )
          //       .then((res) => {
          //         console.log(res.data);
          //         assinatura_id = res.data.data[0].id;

          //         axios
          //           .post(
          //             "https://api2.arecreativa.com.br/delete_subscription",
          //             {
          //               subscription_id: assinatura_id,
          //             }
          //           )
          //           .then((res) => {
          //             console.log(res.data);
          //           });
          //       });
          //   } catch (error) {
          //     this.$store.commit("setStateModal", {
          //       visible: true,
          //       title: "ATENÇÃO",
          //       type: "warning",
          //       message: "Erro ao trocar de assinatura!",
          //     });
          //   }
          // } else {
          //   console.log("Não entrou no IF do cancelamento");
          // }

          self.$axios
            .post("checkout", {
              meio_de_pagamento: "boleto",
              planos_id: self.$store.getters.getItemInCart.payload.id,
            })
            .then((res) => res.data)
            .then(async (res) => {
              self.$store.commit("setStateModal", {
                visible: true,
                title: "Sucesso",
                type: "success",
                message:
                  "Plano gratuito adquirido com sucesso, obrigado pela preferência e bons jogos.",
              });
              await self.$store.commit("loading", false);
              await self.$router.replace({ path: "/" });
            })
            .catch((e) => {
              this.$store.commit("loading", false);
              this.$store.commit("setStateModal", {
                visible: true,
                title: "Erro",
                type: "error",
                message:
                  "Houve um erro ao contratar o plano, tente mais tarde.",
              });
              self.$router.push({ path: "/" });
            });
          this.$store.commit("loading", false);
        } else {
          this.$store.commit("loading", true);

          self.$axios
            .get(`checkout/get_session_id`)
            .then((res) => res.data)
            .then((res) => {
              PagSeguroDirectPayment.setSessionId(res);
              PagSeguroDirectPayment.onSenderHashReady(function (response) {
                if (response.status == "error") return false;
                self.hash = response.senderHash;
                PagSeguroDirectPayment.getInstallments({
                  amount:
                    self.$store.getters.getItemInCart.type === "edicao"
                      ? self.$store.getters.getItemInCart.payload.valor_a_vista
                      : self.$store.getters.getItemInCart.payload.valor_a_prazo,
                  maxInstallmentNoInterest: 12,
                  brand: "visa",
                  success: function (response) {
                    self.$store.commit("loading", false);
                    self.installments = response.installments.visa;
                  },
                  error: function (response) {
                    self.$store.commit("loading", false);
                    console.log(response);
                  },
                  complete: function () {
                    self.$store.commit("loading", false);
                  },
                });
              });
            });
        }
      }
    } else {
      this.$store.commit("setStateModal", {
        visible: true,
        title: "ATENÇÃO",
        type: "warning",
        message: "Faça login para continuar!",
      });
      self.$router.push({ path: "/login" });
    }
  },
  methods: {
    getBrand(number) {
      try {
        let re = new RegExp("^4");
        if (number.match(re) != null) return "visa";

        re = new RegExp("^(34|37)");
        if (number.match(re) != null) return "amex";

        re = new RegExp("^5[1-5]");
        if (number.match(re) != null) return "mastercard";

        re = new RegExp("^6011");
        if (number.match(re) != null) return "discover";

        return "visa"; // default type
      } catch {
        alert("error cartao");
      }
    },
    formatValue: (value) => value.toLocaleString("pt-BR"),
    payCard: async function () {
      let self = this;
      self.$store.commit("loading", true);
      let produtoDesejado;
      let dados;
      let _token;
      let card_id = "";
      //let product_id = "prod_IT7BE5pN9bMrJl"; // TESTE
      let product_id = 'prod_IKuU4LVsvGqXv5' // PRODUÇÃO
      let trial_days = 30;
      let customer_id = decode(localStorage.getItem("t")).usr.stripe_id;

      if (this.id_plano == 12) {
        try {
          this.$axios
            .post("https://api2.arecreativa.com.br/create_card", {
              number: self.cartao.cardNumber.replace(/[^A-Z0-9]+/gi, ""),
              exp_month: self.cartao.validade.substring(1, 2),
              exp_year: self.cartao.validade.substring(3, 7),
              cvc: self.cartao.cvv,
              customer_id,
            })
            .then((res) => {
              console.log("res", res)
              card_id = res.data.id;
              let preco = this.$store.getters.getItemInCart.payload
                .valor_a_vista; // Preço do plano
              console.log(preco + " Preço atual");
              this.$axios
                .post(
                  "https://api2.arecreativa.com.br/create_subscription",
                  {
                    value: parseInt(preco * 100),
                    interval: "month",
                    product_id: product_id,
                    customer_id: customer_id,
                    coupon: self.cupon,
                    trial_days: trial_days,
                    cpf: self.cartao.creditCardHolderCPF.replace(
                      /[^A-Z0-9]+/gi,
                      ""
                    ),
                  }
                )
                .then((res) => {
                  if (res.data.status === "active" || "trialing") {
                    self.criaAssinaturaStripe(res.data.id);
                  } else {
                    self.$store.commit("loading", false);
                    self.$store.commit("setStateModal", {
                      visible: true,
                      title: "ATENÇÃO",
                      type: "warning",
                      message: "Não foi possível criar a assinatura!",
                    });
                  }
                })
                .catch((error) => {
                  console.log(error);
                  self.$store.commit("loading", false);
                  self.$store.commit("setStateModal", {
                    visible: true,
                    title: "ATENÇÃO",
                    type: "warning",
                    message: "Erro ao criar assinatura!",
                  });
                });
            })
            .catch((error) => {
              console.log(error);
              self.$store.commit("loading", false);
              self.$store.commit("setStateModal", {
                visible: true,
                title: "ATENÇÃO",
                type: "warning",
                message: "Erro ao criar assinatura!",
              });
            });
        } catch (error) {
          console.log(error);
          self.$store.commit("loading", false);
          self.$store.commit("setStateModal", {
            visible: true,
            title: "ATENÇÃO",
            type: "warning",
            message: "Erro ao criar assinatura!",
          });
        }
      } else {
        PagSeguroDirectPayment.createCardToken({
          cardNumber: self.cartao.cardNumber.replace(/[^A-Z0-9]+/gi, ""),
          brand: self.getBrand(self.cartao.cardNumber),
          cvv: self.cartao.cvv,
          expirationMonth: self.cartao.validade.substring(0, 2),
          expirationYear: self.cartao.validade.substring(3, 7),

          success: function (response) {
            try {
              _token = response.card.token;
              let info = { ...self.endereco };
              info.meio_de_pagamento = "credito";

              self.$store.getters.getItemInCart.type === "edicao"
                ? (info.edicoes_id =
                    self.$store.getters.getItemInCart.payload.id)
                : (info.planos_id =
                    self.$store.getters.getItemInCart.payload.id);

              info.sender_hash = self.hash;
              info.credit_card_token = _token;
              info.cep = info.cep.replace("-", "");
              info.celular = self.cartao.creditCardHolderPhone.replace(
                /[^A-Z0-9]+/gi,
                ""
              );
              info.installmentQuantity = self.cartao.installmentQuantity;
              info.creditCardHolderName = self.cartao.creditCardHolderName;
              info.creditCardHolderCPF = self.cartao.creditCardHolderCPF.replace(
                /[^A-Z0-9]+/gi,
                ""
              );
              info.creditCardHolderBirthDate =
                self.cartao.creditCardHolderBirthDate.substring(6, 10) +
                "-" +
                self.cartao.creditCardHolderBirthDate.substring(3, 5) +
                "-" +
                self.cartao.creditCardHolderBirthDate.substring(0, 2);
              info.creditCardHolderPhone = self.cartao.creditCardHolderPhone.replace(
                /[^A-Z0-9]+/gi,
                ""
              );
              info.cpf = self.cartao.creditCardHolderCPF.replace(
                /[^A-Z0-9]+/gi,
                ""
              );
              info.cep = info.cep.replace(/[^A-Z0-9]+/gi, "");
              delete info.gia;
              delete info.unidade;
              dados = { ...info };
              self.$axios
                .post("checkout", dados)
                .then((res) => res.data)
                .then((res) => {
                  console.log("success", res);
                  self.$store.commit("loading", false);
                  self.$router.push("/assinatura/finalizado/");
                })
                .catch((err) => {
                  self.$store.commit("loading", false);
                  self.$store.commit("setStateModal", {
                    visible: true,
                    title: "ATENÇÃO",
                    type: "warning",
                    message: "Erro ao realizar pagamento!",
                  });
                });
            } catch (e) {
              self.$store.commit("loading", false);
              console.log("tag", e);
            }
          },
          error: async function (response) {
            self.$store.commit("loading", false);
            await alert(Object.entries(response.errors)[0][1]);
            console.log("err", response);
          },
          complete: function (response) {
            self.$store.commit("loading", false);
          },
        });
      }
    },
    getCep(cep) {
      this.$store.commit("loading", true);
      this.$axios
        .get(`https://viacep.com.br/ws/${cep}/json/`)
        .then((res) => res.data)
        .then((res) => {
          if (res.erro) {
            this.$store.commit("setStateModal", {
              visible: true,
              title: "ATENÇÃO",
              type: "warning",
              message:
                "Não conseguimos encontrar um endereço com esse cep, tente outro cep ou preencha os valores manualmente.",
            });
          } else {
            let info = res;
            info.complemento = "";
            this.endereco = info;
            this.$store.commit("loading", false);
          }
        })
        .catch(() => {
          this.$store.commit("loading", false);
          this.$store.commit("setStateModal", {
            visible: true,
            title: "ATENÇÃO",
            type: "warning",
            message:
              "Não conseguimos encontrar um endereço com esse cep, tente outro cep ou preencha os valores manualmente.",
          });
        });
    },
    criaAssinaturaStripe(subscription_id) {
      console.log("ENTROU");
      let self = this;
      let info = { ...self.endereco };
      self.$store.getters.getItemInCart.type === "edicao"
        ? (info.edicoes_id = self.$store.getters.getItemInCart.payload.id)
        : (info.planos_id = self.$store.getters.getItemInCart.payload.id);
      info.status = 3;

      info.subscription_id = subscription_id; // FAZER MIGRATE DO STRIPE DEPOIS

      info.users_id = decode(localStorage.getItem("t")).usr.id;
      this.$axios
        .post("assinaturas", info)
        .then((res) => res.data)
        .then((res) => {
          self.$store.commit("loading", false);
          self.$store.commit("setStateModal", {
            visible: true,
            title: "Sucesso",
            type: "success",
            message:
              "Plano adquirido com sucesso, obrigado pela preferência e bons jogos.",
          });
          // let token = decode(localStorage.getItem("t"));
          // token.usr.plano.id = 12;
          // localStorage.setItem("t", JSON.stringify(token));

          self.$store.commit("loading", false);
          self.$router.push("/assinatura/finalizado/");
        })
        .catch((err) => {
          console.log(err);
          self.$store.commit("loading", false);
          self.$store.commit("setStateModal", {
            visible: true,
            title: "ATENÇÃO",
            type: "warning",
            message: "Erro ao criar assinatura!",
          });
        });
    },
    setDesconto(cupom) {
      //this.$store.getters.getItemInCart.payload.valor_a_vista
      let self = this;
      let coupon_id = cupom;
      console.log(coupon_id);
      self.$store.commit("loading", true);
      this.$axios
        .get(`https://api2.arecreativa.com.br/show_coupon/${coupon_id}`)
        .then((res) => res.data)
        .then((res) => {
          self.$store.commit("loading", false);
          console.log(res);

          if (res.valid == false) {
            self.$store.commit("setStateModal", {
              visible: true,
              title: "ATENÇÃO",
              type: "warning",
              message: "Este cupom não é valido!",
            });
          } else {
            if (
              res.amount_off >
              this.$store.getters.getItemInCart.payload.valor_a_vista
            ) {
              self.$store.commit("setStateModal", {
                visible: true,
                title: "ATENÇÃO",
                type: "warning",
                message: "Desconto maior que o valor total!",
              });
            } else {
              if (res.amount_off != null) {
                this.$store.getters.getItemInCart.payload.valor_a_vista -= amount_off;
              } else if (res.percent_off != null) {
                this.$store.getters.getItemInCart.payload.valor_a_vista =
                  this.$store.getters.getItemInCart.payload.valor_a_vista -
                  this.$store.getters.getItemInCart.payload.valor_a_vista *
                    (res.percent_off / 100);
              } else {
                console.log("Não descontou nada!");
              }

              PagSeguroDirectPayment.getInstallments({
                amount: this.$store.getters.getItemInCart.payload.valor_a_vista,
                maxInstallmentNoInterest: 12,
                brand: "visa",
                success: function (response) {
                  self.parcelas = response.installments.visa;
                },
                error: function (response) {
                  console.log(response);
                },
                complete: function (response) {},
              });
            }
          }
          this.$axios
            .post(`https://api2.arecreativa.com.br/sum_coupon_uses`, {
              coupon_id,
            })
            .then((res) => {
              console.log(res);
              self.$store.commit("loading", false);
              self.$store.commit("setStateModal", {
                visible: true,
                title: "Sucesso",
                type: "success",
                message: `Cupom aplicado com sucesso! Sua compra será de R$ ${this.$store.getters.getItemInCart.payload.valor_a_vista}`,
              });
            });
        })
        .catch((err) => {
          self.$store.commit("loading", false);
          console.log(err);
          self.$store.commit("setStateModal", {
            visible: true,
            title: "ATENÇÃO",
            type: "warning",
            message: "Cupom inválido!",
          });
        });
    },
    analyticSubmit(){
      //firebase.analytics().setCurrentScreen("WEB_tela_pagamento");
      try {
        firebase.analytics().logEvent("WEB_tela_pagamento"); 
      } catch (error) {
        console.log("analytic pagamento error:", error)
      }
      try {
        this.$intercom.trackEvent("WEB_tela_pagamento");
      } catch (error) {
        console.log("analyticIntercom pagamento error:", error)
      }
    }
  },
};
</script>
<style scoped>
.card {
  padding: 20px !important;
  border: none;
  border-radius: 0px;
  box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.2);
  padding-bottom: 50px !important;
}

.lista-parcelas label {
  font-family: "Agency FB";
  font-size: 12px;
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: 1px;
  color: black;
  margin-bottom: 0px !important;
}

.lista-parcelas select {
  width: 100%;
  font-family: "Agency FB Regular";
  border: none;
  outline: 0;
  font-size: 14px;
  background-color: white;
  border-bottom: solid 1px rgba(0, 0, 0, 0.1);
  padding: 0px;
}

.subtitle {
  text-transform: uppercase;
  letter-spacing: 2px;
}

.btn-finalizar {
  border: none;
  background-color: #8d4d9a;
  color: white;
  text-transform: uppercase;
  width: 50%;
  height: 30px;
  font-size: 15px;
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>